import { Infills } from "../infills/model/infills";

/**
 *@description
 * https://prnt.sc/qvlvxh
 * @param {any} baserail
 * @param {any} pos pos1 or pos2 (from post position)
 * @returns {any}
 * @function
 */
export const getBaserailLevelPosPoint = (baserail, infillType: Infills, pos) => {
  let point;

  switch (infillType) {
    case Infills.horizontal: {
      point = pos
        .clone()
        .setY(
          pos.y + baserail.userData.entity.placementHeight + baserail.userData.entity.height / 2
        );
      break;
    }
    case Infills.stairs: {
      point = pos.clone().setY(pos.y + 15);
      break;
    }
    case Infills.stairsLanding: {
      point = pos.clone().setY(pos.y + 6);
      break;
    }
    case Infills.tires: {
      point = pos.clone().setY(pos.y + 20);
      break;
    }
  }

  return point;
};


// WEBPACK FOOTER //
// ./src/app/services/railing/utils/get-baserail-level-pos-point.ts